export const DEFAULT_MORTGAGE_REMINDER = {
  maturity: [],
  title: [],
  legal: [],
  lender: [],
  interest: []
}
